import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_34: FaireProductEntity = {
  token: "catalog_prod_prod-34",
  type: "product",
  name: "Serving Piece",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 62.87,
  msrpDollars: 157.17,
  sku: "PA0034",
  caseSize: 3,
  material: "Ceramic",
  collectionToken: "col_pattern-play",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 468,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_crafts-hobbies"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
